import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { DasboardProvider } from "./contexts/DashboardContext";
import ScrollToHash from "./components/ScrollToHash";
import { cssTransition, toast, ToastContainer, Zoom } from "react-toastify";
import { ChatBotProvider } from "./contexts/ChatBotContext";
import "./assets/css/bootstrap.min.css";
import "./assets/css/botbuddy_dashboard.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./App.css";
import "./index.css";

const customTransition = cssTransition({
  enter: "fadeIn",
  exit: "fadeOut",
  duration: [300, 300], // <-- change transition duration here (ms)
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode> /* Strict mode is commneted by Sharmishtha to use package react-beautiful-dnd in react 18*/
  <BrowserRouter>
    <ScrollToHash />
    <ToastContainer
      transition={Zoom}
      autoClose={3000}
      hideProgressBar
      newestOnTop
      pauseOnFocusLoss={false}
      pauseOnHover={true}
      position="top-right"
      toastStyle={{
        backdropFilter: "blur(10px)",
        background: "rgba(255,255,255,0.75)",
        color: "#1a1a1a",
        borderRadius: "14px",
        border: "1px solid rgba(255,255,255,0.6)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08), 0 12px 32px rgba(0,0,0,0.06)",
      }}
    />

    <DasboardProvider>
      <AuthProvider>
        <ChatBotProvider>
          <App />
        </ChatBotProvider>
      </AuthProvider>
    </DasboardProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
